module.exports = __webpack_public_path__ + "img/outpatientPersonNumber.e2084ff3.svg";